/**
 * useSessionStorageValue をラップした hook
 * @description https://react-hookz.github.io/web/?path=/docs/side-effect-usesessionstoragevalue--example
 * @description GitHub: https://github.com/react-hookz/web
 */
import { useSessionStorageValue } from '@react-hookz/web';
export const useSessionStorage = useSessionStorageValue;
